/** @jsx jsx */
import { jsx } from '@emotion/react'
import { fazemosParteDaRedeBertoniStyles } from '../assets/styles/FazemosParteDaRedeBertoni.styles'
import { Col, Container, Row } from 'react-bootstrap'
import LogoBertKids from '../assets/images/LP-arabe/REDE/logo-bert-kids.svg'
import LogoBertoniElos from '../assets/images/LP-arabe/REDE/logo-bertoni-elos.svg'
import LogoTeamSix from '../assets/images/LP-arabe/REDE/logo-team-six.svg'
import LogoBertoniPro from '../assets/images/LP-arabe/REDE/logo-bertoni-pro.svg'
import LogoSalaPro from '../assets/images/LP-arabe/REDE/logo-sala-pro.svg'
import LogoColegioBertoni from '../assets/images/LP-arabe/REDE/logo-colegio-bertoni.svg'

const FazemosParteDaRedeBertoni = () => {
  return (
    <section css={fazemosParteDaRedeBertoniStyles}>
      <Container>
        <Row data-aos="fade-down" data-aos-delay="500" className='title-sec'>
          <Col lg={6} md={6} sm={12}>
            <h2>Fazemos parte da <span>Rede Bertoni</span></h2>
          </Col>
          <Col lg={1} md={1} sm={12} />
          <Col lg={5} md={5} sm={12}>
            <p>Referência em educação de excelência e resultados acadêmicos no Brasil e no Paraguai.</p>
          </Col>
        </Row>
        <Row data-aos="fade-left" data-aos-delay="300">
          <Col lg={4} md={4} sm={6} >
            <div className='img'>
              <img src={LogoBertKids} alt="Bert Kids" />
            </div>
          </Col>
          <Col lg={4} md={4} sm={6} >
            <div className='img'>
              <img src={LogoBertoniElos} alt="Bertoni Elos" />
            </div>
          </Col>
          <Col lg={4} md={4} sm={12} >
            <div className='img'>
              <img src={LogoTeamSix} alt="Team Six - Elite Militar" />
            </div>
          </Col>
        </Row>
        <Row data-aos="fade-right" data-aos-delay="400">
          <Col lg={4} md={4} sm={12} >
            <div className='img'>
              <img src={LogoBertoniPro} alt="Bertoni Pro" />
            </div>
          </Col>
          <Col lg={4} md={4} sm={12} >
            <div className='img'>
              <img src={LogoSalaPro} alt="Sala Pro Carolina" />
            </div>
          </Col>
          <Col lg={4} md={4} sm={12} >
            <div className='img'>
              <img src={LogoColegioBertoni} alt="Colégio Bertoni" />
            </div>
          </Col>
        </Row>
      </Container>
      {/* <img src={studentWithTeacher} alt="Crianças juntas com a professora" /> */}
    </section>
  )
}

export default FazemosParteDaRedeBertoni;
